<div class="page-content min-h-100">
    <p-panel [header]="project ? project.name : '...'">
        @if (showLoading) {
            <div class="text-center">
                <p-progressSpinner
                    styleClass="w-4rem h-4rem"
                    strokeWidth="4"
                    animationDuration="1.5s"
                ></p-progressSpinner>
                <div class="mt-2 mb-2">{{ loadingStr }}</div>
            </div>
        } @else {
            <p-tabs [(value)]="currentTab">
                <p-tablist>
                    <p-tab [value]="EProjectTab.GENERAL" ariaLabel="General information tab">Overview</p-tab>
                    <p-tab [value]="EProjectTab.SERVICE_REQUESTS" ariaLabel="Service requests tab"
                        >Service Requests</p-tab
                    >
                    <p-tab [value]="EProjectTab.FILES" ariaLabel="Files tab">Files</p-tab>
                    <p-tab [value]="EProjectTab.OBJECT_STORE" ariaLabel="Object store tab">Object Store</p-tab>
                </p-tablist>

                <p-tabpanels> </p-tabpanels>
            </p-tabs>

            @switch (currentTab) {
                @case (EProjectTab.GENERAL) {
                    @if (project) {
                        <app-project-general-info
                            [project]="project"
                            [refreshTrigger$]="refreshStatistics$.asObservable()"
                        ></app-project-general-info>
                    } @else {
                        <div class="mb-4 mt-4 text-center"><b>Project not found!</b></div>
                    }
                }
                @case (EProjectTab.SERVICE_REQUESTS) {
                    @if (project) {
                        <app-service-request-crud
                            [showProject]="false"
                            [projectUUID]="project.uuid"
                            (serviceRequestChanged)="refreshStatistics$.next()"
                        ></app-service-request-crud>
                    } @else {
                        <div class="mb-4 mt-4 text-center"><b>Project not found!</b></div>
                    }
                }
                @case (EProjectTab.FILES) {
                    <!-- Files Panel -->
                    <!-- TODO: Backend modification needed - Add project_uuid to CpmCCustomerFileEntryApiModel
                         to enable filtering files by project. Currently shows all customer files. -->
                    @if (project) {
                        <app-user-file-crud></app-user-file-crud>
                    } @else {
                        <div class="mb-4 mt-4 text-center"><b>Project not found!</b></div>
                    }
                }
                @case (EProjectTab.OBJECT_STORE) {
                    @if (project) {
                        <app-object-store-entry-crud
                            [linkObjectType]="'project'"
                            [linkObjectUUID]="project.uuid"
                            (objectStoreChanged)="refreshStatistics$.next()"
                        ></app-object-store-entry-crud>
                    } @else {
                        <div class="mb-4 mt-4 text-center"><b>Project not found!</b></div>
                    }
                }
            }
        }
    </p-panel>
</div>
